


































import { Component, PropSync } from 'vue-property-decorator'
import { Action } from "vuex-class";
import BaseFilter from "@/components/Filter/BaseFilter";
import {SelectWings, ToggleWings} from "wings-ui-components";
import { PushApplicationFilterParams } from '@/store/push/application/types';
import {getTranslatedParams} from "@/utils/notify-utils";

@Component({components: {SelectWings, ToggleWings}})
export default class PushApplicationsFilter extends BaseFilter<PushApplicationFilterParams>{
  @PropSync('show') is_show!: boolean;
  @Action("getPushApplications") actionGetApplications: any;

  defaultFilter(): PushApplicationFilterParams {
    return {
      name: undefined,
      description: undefined,
    }
  }

  created() {
    this.filtered();
  }

  async onFilteredAction() {
    try {
      this.logObject = {
        action_page: this.$route.meta.msgKey,
        action: "Viewing",
        action_status: "success",
        object_type: "Push application",
        addititional_info: getTranslatedParams(this.filter)
      };
      await this.actionGetApplications(this.filter);
      await this.actionLog(this.logObject);
    }
    catch (err){
      await this.actionLog({...this.logObject, action_status: "failed"});
    }
  }
}
